import styled from 'styled-components';

const Head = styled.thead`
  text-align: left;

  tr:first-of-type {
    display: none;
  }
`;

const TR = styled.tr``;

const TH = styled.th`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 2rem 1.5rem;
`;

const SortIcon = styled.span`
  display: inline-block;
  margin-left: 0.6rem;
`;

export { Head, TR, TH, SortIcon };
